import { $ } from "../third-party-imports";
import { domLoaded } from '@nbly/crownpeak';

domLoaded(() => {
    $('.dropdown-toggle').dropdown();
})